import React from "react";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import classNames from "classnames";

import Icon from "components/library/Icon";
import withTooltip from "components/library/Tooltip/withTooltip";
import logo from "assets/img/logo.png";
import Button from "components/library/Button";
import { toggleSidebar } from "actions/sidebar";

import styles from "./NavigationSidebar.css";

const IconWithTooltip = withTooltip(Icon);

class NavigationSidebar extends React.Component {
  constructor(props) {
    super(props);

    /* TODO: DRY with NavigationHeader */
    this.links = [
      {
        icon: "edit",
        text: "Writing & Editing",
        to: "/dashboard/",
      },
      {
        icon: "image",
        text: "Image library",
        to: "/illos",
      },
      {
        icon: "tag",
        text: "Tags",
        to: "/settings/tags",
      },
      {
        icon: "users",
        text: "Users",
        to: "/settings/users",
      },
      {
        icon: "settings",
        text: "Your account",
        to: "/settings/users/me",
      },
      {
        icon: "log-out",
        text: "Log out",
        to: "/logout",
      },
    ];
  }

  render() {
    const { isExpanded, toggleSidebar } = this.props;

    if (isExpanded) {
      return (
        <div
          className={classNames(styles.root, styles.expanded)}
          data-cy="expandedSidebarNav"
        >
          <Button
            className={styles.toggle}
            onClick={toggleSidebar}
            type="tertiary"
            data-cy="toggleSidebar"
          >
            <Icon name="chevron-left" className={styles.chevron} />
          </Button>
          <img src={logo} className={styles.logo} />
          <nav className={styles.nav}>
            {this.links.map(({ icon, to, text }) => (
              <NavLink
                activeClassName={styles.active}
                className={styles.link}
                exact
                key={text}
                to={to}
              >
                <Icon name={icon} className={styles.icon} />
                <span>{text}</span>
              </NavLink>
            ))}
          </nav>
        </div>
      );
    } else {
      return (
        <div className={styles.root} data-cy="sidebarNav">
          <Button
            className={styles.toggle}
            onClick={toggleSidebar}
            type="tertiary"
          >
            <Icon name="chevron-right" className={styles.chevron} />
          </Button>
          <img src={logo} className={styles.logo} />
          <nav className={styles.nav}>
            {this.links.map(({ icon, to, text }) => (
              <NavLink
                activeClassName={styles.active}
                className={styles.link}
                exact
                key={text}
                to={to}
              >
                <IconWithTooltip
                  name={icon}
                  className={styles.icon}
                  tooltip={text}
                />
              </NavLink>
            ))}
          </nav>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    isExpanded: state.isSidebarExpanded,
  };
};

export default connect(
  mapStateToProps,
  { toggleSidebar }
)(NavigationSidebar);
